import {useMemo} from "react";

const FilterBtn = ({item, setFilter, filter, setIsToggle}) => {
    let name = item || "ALL";

    const handleToggle = () => {
        if (setIsToggle) setIsToggle(false);
        setFilter(name);
    };

    return (
        <div
            className={`filter__btn gray ${name === filter ? "filter__btn-active" : ""}`}
            onClick={handleToggle}
        >
            {/*<span className="filter__bg btn-bg"></span>*/}
            <div className="filter__text regular">{name}</div>
        </div>
    );
};

export default FilterBtn;
